<div class="credit-register-page">

	<div class="page-intro">
		<b3-breadcrumbs aria-label="Breadcrumb">
			<b3-breadcrumbs-item variant="icon" href="/"></b3-breadcrumbs-item>
			<b3-breadcrumbs-item variant="item">Operações de crédito</b3-breadcrumbs-item>
			<b3-breadcrumbs-item variant="item">Operações</b3-breadcrumbs-item>
			<b3-breadcrumbs-item variant="item">Registrar</b3-breadcrumbs-item>
		</b3-breadcrumbs>
		<h1 class="page-title">Registro de Créditos de Carbono</h1>
	</div>

	<form class="credit-register-form" [formGroup]="formRegister">
		<div class="form-layout">
			<div class="form-shell">
				<div class="section-block">
					<div class="section-header">
						<div class="section-header__title-group">
							<span class="section-header__accent" aria-hidden="true"></span>
							<h2 class="section-header__title">Detalhes do registro</h2>
						</div>
						<span class="section-header__divider" aria-hidden="true"></span>
					</div>
					<div class="fields-row fields-row--3">
						<div class="field-group field-group--labeled">
							<b3-input-text
								formControlName="cnpj"
								inputId="cnpj"
								label="CNPJ do registrador"
								background="white"
								[mask]="registrarCnpjMask"
								placeholder="00.000.000/0000-00"
								[error]="checkHasError('cnpj')"
								[hint]="[
									{ show: checkHasError('cnpj', 'required'), text: 'Campo obrigatório' },
									{ show: checkHasError('cnpj'), text: 'Insira um CNPJ válido' }
								] | fieldHint"
								(b3-blur)="onChangesInputCpfOrCnpj()">
							</b3-input-text>
						</div>
						<div class="field-group field-group--labeled">
							<b3-input-text
								formControlName="registerNumber"
								inputId="registerNumber"
								label="Conta registrador"
								background="white"
								mask="account"
								placeholder="00000.40-0"
								[error]="checkHasError('registerNumber')"
								[hint]="[
									{ show: checkHasError('registerNumber', 'required'), text: 'Campo obrigatório' },
									{ show: checkHasError('registerNumber'), text: 'Insira uma conta miolo (40) válida' }
								] | fieldHint">
							</b3-input-text>
						</div>
						<div class="field-group field-group--holder-column">
							<div class="field-group field-group--labeled">
								<b3-input-text
									formControlName="holderNumber"
									inputId="holder"
									label="Conta detentor"
									background="white"
									mask="account"
									placeholder="00000.00-0"
									[error]="checkHasError('holderNumber')"
									[hint]="[
										{ show: checkHasError('holderNumber', 'required'), text: 'Campo obrigatório' },
										{ show: checkHasError('holderNumber'), text: 'Insira uma conta miolo (00) ou miolo (10)' }
									] | fieldHint">
								</b3-input-text>
							</div>
							<div class="field-group field-group--labeled tooltip-container" *ngIf="showHolderCpfCnpj">
								<b3-input-text
									formControlName="holderCpfCnpj"
									inputId="holderCpfCnpj"
									label="CPF/CNPJ do Comitente"
									background="white"
									[mask]="holderDocumentMask"
									placeholder="00.000.000/0000-00"
									[maxlength]="18"
									[error]="checkHasError('holderCpfCnpj') && !comitenteFound"
									[hint]="[
										{ show: comitenteFound, text: 'Comitente encontrado para conta' },
										{ show: checkHasError('holderCpfCnpj', 'required'), text: 'Campo obrigatório' },
										{ show: checkHasError('holderCpfCnpj', 'comitenteInvalido'), text: 'Comitente não encontrado para esta conta' },
										{ show: checkHasError('holderCpfCnpj'), text: 'CPF/CNPJ inválido' }
									] | fieldHint"
									(b3-blur)="onChangesHolderCpfOrCnpj()">
								</b3-input-text>
								<span class="tooltip-text">Preencha o CPF/CNPJ do comitente da conta 10</span>
							</div>
						</div>
					</div>
				</div>

				<div class="section-block">
					<div class="section-header">
						<div class="section-header__title-group">
							<span class="section-header__accent" aria-hidden="true"></span>
							<h2 class="section-header__title">Projeto</h2>
						</div>
						<span class="section-header__divider" aria-hidden="true"></span>
					</div>
					<div class="fields-row fields-row--2">
						<div class="field-group field-group--labeled">
							<b3-input-text
								formControlName="projectName"
								inputId="projectName"
								label="Nome do Projeto"
								background="white"
								mask="text"
								placeholder="Limite 200 caracteres"
								[error]="checkHasError('projectName')"
								[hint]="[
									{ show: checkHasError('projectName', 'required'), text: 'Campo obrigatório' },
									{ show: checkHasError('projectName'), text: 'Preenchimento inválido' }
								] | fieldHint">
							</b3-input-text>
						</div>
						<div class="field-group field-group--labeled">
							<b3-input-text
								formControlName="projectId"
								inputId="projectId"
								label="ID do projeto"
								background="white"
								mask="text"
								placeholder="Limite 20 caracteres"
								[error]="checkHasError('projectId')"
								[hint]="[
									{ show: checkHasError('projectId', 'required') && !checkHasError('projectId', 'invalidBySerialRange'), text: 'Campo obrigatório' }
								] | fieldHint">
							</b3-input-text>
						</div>
					</div>
				</div>

				<div class="section-block">
					<div class="section-header">
						<div class="section-header__title-group">
							<span class="section-header__accent" aria-hidden="true"></span>
							<h2 class="section-header__title">Emissão do crédito</h2>
						</div>
						<span class="section-header__divider" aria-hidden="true"></span>
					</div>
					<div class="fields-row fields-row--2">
						<div class="field-group field-group--labeled">
							<b3-datepicker
								inputId="data"
								label="Data da emissão"
								formControlName="data"
								background="white"
								placeholder="DD/MM/AAAA"
								locale="pt-BR"
								[min]="minDateIso"
								[max]="maxDateIso"
								[error]="checkHasError('data') || isInvalidRegistryDate"
								[hint]="[
									{ show: checkDateFieldError('data', 'required'), text: 'Campo obrigatório' },
									{ show: checkDateFieldError('data', 'emissionAfterSafraStart'), text: 'Data da emissão não pode ser posterior à data da safra' },
									{ show: isInvalidRegistryDate, text: 'Data inválida' }
								] | fieldHint"
								(b3-change)="onRegistryDateChange($event)">
							</b3-datepicker>
						</div>
						<div class="field-group field-group--labeled field-group--quantity">
							<div class="input-with-suffix">
								<b3-input-text
									formControlName="creditQuantity"
									inputId="creditQuantity"
									label="Quantidade de créditos registrados"
									background="white"
									mask="integer"
									placeholder="Apenas números inteiros"
									[error]="checkHasError('creditQuantity')"
									[hint]="[
										{ show: checkHasError('creditQuantity', 'required'), text: 'Campo obrigatório' },
										{ show: checkHasError('creditQuantity'), text: 'Preenchimento inválido' }
									] | fieldHint">
								</b3-input-text>
								<span class="input-with-suffix__suffix">tCO2</span>
							</div>
						</div>
					</div>
				</div>

				<div class="section-block">
					<div class="section-header">
						<div class="section-header__title-group">
							<span class="section-header__accent" aria-hidden="true"></span>
							<h2 class="section-header__title">Safra</h2>
						</div>
						<span class="section-header__divider" aria-hidden="true"></span>
					</div>
					<div class="fields-row fields-row--2">
						<div class="field-group field-group--labeled">
							<b3-datepicker
								inputId="safraIDate"
								label="Data inicial"
								formControlName="safraIDate"
								background="white"
								placeholder="DD/MM/AAAA"
								locale="pt-BR"
								[min]="minDateIso"
								[max]="maxDateIso"
								[error]="checkHasError('safraIDate') || invalidStartDate"
								[hint]="[
									{ show: checkDateFieldError('safraIDate', 'required'), text: 'Campo obrigatório' },
									{ show: invalidStartDate, text: 'Data inválida' }
								] | fieldHint"
								(b3-change)="onSafraStartDateChange($event)">
							</b3-datepicker>
						</div>
						<div class="field-group field-group--labeled">
							<b3-datepicker
								inputId="safraFDate"
								label="Data final"
								formControlName="safraFDate"
								background="white"
								placeholder="DD/MM/AAAA"
								locale="pt-BR"
								[min]="minSafraFDateIso"
								[max]="maxDateIso"
								[error]="checkHasError('safraFDate') || invalidEndDate"
								[hint]="[
									{ show: checkDateFieldError('safraFDate', 'required'), text: 'Campo obrigatório' },
									{ show: invalidEndDate, text: 'Data inválida' }
								] | fieldHint"
								(b3-change)="onSafraEndDateChange($event)">
							</b3-datepicker>
						</div>
					</div>
				</div>

				<div class="section-block">
					<div class="section-header">
						<div class="section-header__title-group">
							<span class="section-header__accent" aria-hidden="true"></span>
							<h2 class="section-header__title">Certificação</h2>
						</div>
						<span class="section-header__divider" aria-hidden="true"></span>
					</div>
					<div class="brcer-row" *ngIf="isCdmCertifierSelected">
						<b3-checkbox
							label="BRCER"
							[selected]="!!formRegister.get('brcerAccepted')?.value"
							(b3-change)="onBrcerAcceptedChange($event)">
						</b3-checkbox>
					</div>
					<div class="fields-row fields-row--2">
						<div class="field-group field-group--labeled">
							<b3-input-select
								formControlName="certifier"
								inputId="certifier"
								label="Certificadora"
								placeholder="Selecione a certificadora"
								background="white"
								maxHeight="280px"
								[options]="selectItens"
								[error]="checkHasError('certifier')"
								[hint]="[
									{ show: checkHasError('certifier', 'required'), text: 'Campo obrigatório' },
									{ show: checkHasError('certifier'), text: 'Preenchimento inválido' }
								] | fieldHint">
								<b3-input-select-option
									*ngFor="let item of selectItens; let i = index"
									[attr.value]="item.inputId"
									[attr.index]="i"
									[id]="'certifier-option-' + item.inputId">
									{{ item.label }}
								</b3-input-select-option>
							</b3-input-select>
						</div>
						<div class="field-group field-group--labeled" *ngIf="!isCdmCertifierSelected">
							<b3-input-text
								formControlName="serialCode"
								inputId="serialCode"
								label="Serial Range / Credit ID"
								background="white"
								mask="text"
								placeholder="Limite 200 caracteres"
								[error]="checkHasError('serialCode')"
								[hint]="[
									{ show: checkHasError('serialCode', 'required'), text: 'Campo obrigatório' }
								] | fieldHint">
							</b3-input-text>
						</div>
						<div class="field-group field-group--labeled" *ngIf="isCdmCertifierSelected">
							<span class="field-label">Serial Range / Credit ID</span>
							<div class="serial-split">
								<b3-input-text
									formControlName="serialCodeStart"
									inputId="serialCodeStart"
									background="white"
									mask="text"
									placeholder="Block Start"
									[error]="checkHasError('serialCodeStart')">
								</b3-input-text>
								<b3-input-text
									formControlName="serialCodeEnd"
									inputId="serialCodeEnd"
									background="white"
									mask="text"
									placeholder="Block End"
									[error]="checkHasError('serialCodeEnd')">
								</b3-input-text>
							</div>
							<app-field-message
								[show]="checkHasError('serialCodeStart', 'required') || checkHasError('serialCodeEnd', 'required')"
								status="error">Campo obrigatório</app-field-message>
						</div>
					</div>
					<div class="fields-row fields-row--1">
						<div class="field-group field-group--labeled">
							<b3-input-text
								formControlName="linkProject"
								inputId="linkProject"
								label="Link do projeto na certificadora"
								background="white"
								mask="text"
								placeholder="Limite 200 caracteres"
								[error]="checkHasError('linkProject')"
								[hint]="[
									{ show: checkHasError('linkProject', 'required'), text: 'Campo obrigatório' },
									{ show: checkHasError('linkProject', 'whitespace'), text: 'O campo não pode conter espaços' }
								] | fieldHint">
							</b3-input-text>
						</div>
					</div>
					<div class="fields-row fields-row--1">
						<div class="field-group field-group--labeled field-group--textarea">
							<b3-input-area
								formControlName="description"
								inputId="description"
								label="Descrição do projeto"
								background="white"
								placeholder="Limite 500 caracteres"
								[error]="checkHasError('description') || characterCount >= 500"
								[hint]="[
									{ show: characterCount >= 500, text: 'Limite atingido' },
									{ show: checkHasError('description', 'required'), text: 'Campo obrigatório' },
									{ show: checkHasError('description'), text: 'Preenchimento inválido' }
								] | fieldHint">
							</b3-input-area>
							<p class="character-count" [class.character-count--limit]="characterCount >= 500">
								{{ characterCount }}/500
							</p>
						</div>
					</div>
				</div>
			</div>

			<div class="aceite-card" *ngIf="isCdmCertifierSelected">
				<div class="section-header">
					<div class="section-header__title-group">
						<span class="section-header__accent" aria-hidden="true"></span>
						<h2 class="section-header__title">Aceite</h2>
					</div>
					<span class="section-header__divider" aria-hidden="true"></span>
				</div>
				<p class="aceite-text">Documentação submetida à B3.</p>
				<b3-checkbox
					label="Confirmar"
					[selected]="!!formRegister.get('aceiteAccepted')?.value"
					(b3-change)="onAceiteAcceptedChange($event)">
				</b3-checkbox>
				<app-field-message [show]="checkHasError('aceiteAccepted', 'required')" status="error">Campo obrigatório</app-field-message>
			</div>

			<div class="form-actions" role="group" aria-label="Ações do formulário">
				<b3-button
					type="button"
					variant="ghost"
					tone="default"
					class="form-actions__btn-cancel"
					(b3-click)="onCancel()">
					Cancelar
				</b3-button>
				<b3-button
					type="button"
					variant="filled"
					tone="default"
					class="form-actions__btn-submit"
					[disabled]="!canSubmit"
					(b3-click)="onRegisterClick()">
					<b3-icon name="check_circle" size="md" tone="on-brand"></b3-icon>
					Registrar Créditos
				</b3-button>
			</div>
		</div>
	</form>

	<footer class="page-footer">
		<p class="page-footer__text">B3SA© 2026 Plataforma de Carbono. Todos os direitos reservados.</p>
	</footer>
</div>

<app-modal-credit-register-success
	*ngIf="successViewModel"
	[open]="showSuccessModal"
	[viewModel]="successViewModel"
	(action)="onSuccessModalAction($event)">
</app-modal-credit-register-success>

<app-modal-credit-register-error
	*ngIf="errorViewModel"
	[open]="showErrorModal"
	[viewModel]="errorViewModel"
	(action)="onErrorModalAction()">
</app-modal-credit-register-error>

<app-modal-credit-register-info
	*ngIf="infoViewModel"
	[open]="showInfoModal"
	[viewModel]="infoViewModel"
	(action)="onInfoModalAction()">
</app-modal-credit-register-info>
